import { StakeSelector } from "@lib/titan2-slingo/dist/game/view/abstract/display/StakeSelector";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { DestroyUtil } from "@lib/titan2/dist/util/view/DestroyUtil";
/**
 * GameStakeSelector.ts
 */
export class GameStakeSelector extends StakeSelector {
    create() {
        this.mouseBlocker = new MouseBlocker(this.landscapeProperties.mouseBlockerProperties, this.portraitProperties.mouseBlockerProperties);
        this.mouseBlocker.onClick(this.handleMouseBlockerSelected, this);
        super.create();
    }
    handleToggleButtonSelected() {
        this.addChild(this.mouseBlocker);
        super.handleToggleButtonSelected();
        this.dispatchCore(CommonGameEvent.STAKE_SELECTOR_OPEN);
    }
    handleMouseBlockerSelected() {
        this.close();
        this.dispatchCore(CommonGameEvent.STAKE_SELECTOR_CLOSE);
    }
    handleCloseToggleComplete() {
        this.removeChild(this.mouseBlocker);
        super.handleCloseToggleComplete();
    }
    updateValues() {
        this.destroyPanelChildren(this.panel);
        this.createValueButtons();
        this.createTop(this.panel);
        this.createBottom(this.panel);
        this.createValueHolderMask();
        this.refresh(false);
    }
    destroyPanelChildren(panel) {
        for (let i = 0; i < panel.getTotalChildren(); i++) {
            const child = panel.getPanelChildAt(i);
            DestroyUtil.destroy(child);
        }
        this.panel.removeAll();
    }
}
//# sourceMappingURL=GameStakeSelector.js.map